import { Injectable, signal, computed, effect, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private readonly document = inject(DOCUMENT);
    private readonly STORAGE_KEY = 'theme';
    private readonly _isDark = signal<boolean>(false);
    readonly isDark = computed(() => this._isDark());

    constructor() {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        const prefersDark = stored
            ? stored === 'dark'
            : window.matchMedia('(prefers-color-scheme: dark)').matches;
        this._isDark.set(prefersDark);

        effect(() => {
            const dark = this._isDark();
            const html = this.document.documentElement;
            dark ? html.classList.add('dark') : html.classList.remove('dark');
        });
    }

    toggle(): void {
        const next = !this._isDark();
        this._isDark.set(next);
        localStorage.setItem(this.STORAGE_KEY, next ? 'dark' : 'light');
    }
}
